import React from 'react'

import './style.scss'

const Status = props => {
  return (
    <>
      {props.deprecated ? (
        <div className="c-notification--warning l-margin-bottom--xxlarge">
          <div className="c-notification__icon">
            <i className="icon icon--exclamation"></i>
          </div>
          <div className="c-notification__content">
            This component or pattern has been deprecated and will be removed.
          </div>
        </div>
      ) : props.designOnly ? (
        <div className="c-notification--warning l-margin-bottom--xxlarge">
          <div className="c-notification__icon">
            <i className="icon icon--exclamation"></i>
          </div>
          <div className="c-notification__content">
            This component is not yet coded. For questions or to offer
            development contribution, please reach out to the Currency team
          </div>
        </div>
      ) : props.inProgress ? (
        <div className="c-notification--warning l-margin-bottom--xxlarge">
          <div className="c-notification__icon">
            <i className="icon icon--exclamation"></i>
          </div>
          <div className="c-notification__content">
            This page's guidelines are under construction. For questions on this
            component's use, please reach out to the Currency team.
          </div>
        </div>
      ) : null}
    </>
  )
}

export default Status
